import { useContext } from "react";
import { UserContext } from "./UserContext";

export const useProfile = () => {
  const { profile, isLoggedIn } = useContext(UserContext);

  return { profile, isLoggedIn };
};
